import React, { useEffect, useRef, useState } from "react";
import CompanyHeader from "../../components/CompanyHeader";
import CompanySideMenu from "../../components/CompanySideMenu";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import Papa from "papaparse";
import { useSnackbar } from "notistack";
import CustomToast from "../../components/CustomToast";
import { LoadingSpinner } from "../../components/Icons";
import ReturnButton from "../../components/ReturnButton";
import CustomButton from "../../components/CustomButton";
import * as Encoding from 'encoding-japanese';
import Copyright from "../../components/Copyright";
import i18n from 'i18next';
import { downloadFileAttachment, getItemsByPage } from "utils/util";
import { useDispatch, useSelector } from "react-redux";
import { MAX_FILE_SIZE } from '../../constants/index';
import {
  setLoading,
  importTalent,
  savingImportTalent,
  setResultImport,
  setListImportSuccess,
  setListImportError,
  setCurrentPageSuccess,
  setCurrentPageError,
} from "../../reducers/companyTalent";
import { convertToFullDate, formatName } from "utils/format";
import { ThunkDispatch } from "@reduxjs/toolkit";
import CustomPagination from "components/CustomPagination";

const errorTableHeaders = ["行", "列", "ステータス", "エラー内容"];
const headers = ["氏名", "名前カナ", "メールアドレス", "性別", "生年月日", "社員番号", "居住地", "種別"];
const headerField = [
  {label: "姓", field: "last_name"},
  {label: "名", field: "first_name"},
  {label: "姓カナ", field: "last_name_kana"},
  {label: "名カナ", field: "first_name_kana"},
  {label: "種別", field: "talent_type"},
  {label: "メールアドレス", field: "email"},
  {label: "生年月日", field: "birth_date"},
  {label: "居住地", field: "city"},
  {label: "性別", field: "gender"},
  {label: "タレントタグ", field: "talent_tag"},
  {label: "経験職種１", field: "occupation_1"},
  {label: "経験職種２", field: "occupation_2"},
  {label: "経験職種３", field: "occupation_3"},
  {label: "経験業種１", field: "industry_1"},
  {label: "経験業種２", field: "industry_2"},
  {label: "経験業種３", field: "industry_3"},
  {label: "リファラルフラグ", field: "is_referred"},
  {label: "紹介者 自由入力", field: "referral_hiring"},
  {label: "在籍時の最終部署・社名", field: "department"},
  {label: "在籍期間 入社年", field: "join_company_year"},
  {label: "在籍期間 入社月", field: "join_company_month"},
  {label: "在籍期間 退社年", field: "leave_company_year"},
  {label: "在籍期間 退社月", field: "leave_company_month"},
  {label: "退社年月日", field: "leave_company_day"},
  {label: "社員番号", field: "employee_number"},
  {label: "登録申請時メモ", field: "registration_memo"},
  {label: "本人確認テキストラベル", field: "identity_verification_text_label"},
  {label: "本人確認テキスト", field: "identity_verification_text"}
];

const TalentCSV = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [isOver, setIsOver] = useState(false);
  const [fileLoaded, setFileLoaded] = useState(false);
  const [fileDecodedString, setFileDecodedString] = useState<string | null>(null);
  const fileRef = useRef<any>(null);
  const navigate = useNavigate();
  const [errorTable, setErrorTable] = useState<any>([]);
  const [errorLoaded, setErrorLoaded] = useState(false);
  const [file, setFile] = useState<any>(null);
  const [tableData, setTableData] = useState<any>([]);
  const {
    loading,
    resultImport,
    listImportSuccess,
    listImportError,
    currentPageSuccess,
    currentPageError,
    importPageSize,
    actionName,
    actionStatus,
    message,
    isSuccess,
  } = useSelector((state: any) => state.companyTalent);

  const handleChangeFile = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      const fileUpload = e.target.files[0];
      validateFileUpload(fileUpload);
    }
    e.target.value = '';
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
    if (loading) return;
    setIsOver(true);
  };

  const handleDragLeave = (e: any) => {
    e.preventDefault();
    if (loading) return;
    setIsOver(false);
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    if (loading) return;
    setIsOver(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const droppedFile = e.dataTransfer.files[0];
      validateFileUpload(droppedFile);
    }
  };

  const handleClick = () => {
    if (loading) return;
    fileRef.current.click();
  };

  const showToast = (title: string, message: string, variant: string, type="normal") => {
    enqueueSnackbar('I love snacks.', {
      content: (key) => (
        <CustomToast title={title} message={message} variant={variant} snackbarKey={key} closeSnackbar={closeSnackbar} type={type} />
      ),
    });
  };

  const validateFileUpload = (fileUpload: any) => {
    const allowedExtensions = ['csv'];
    const fileExtension = fileUpload.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      showToast('メッセージ', i18n.t('MSG_JOB_SELECT_FILE_CSV_FORMAT'), 'error');
      return;
    }

    if (fileUpload.size > MAX_FILE_SIZE.IMPORT_TALENT) {
      showToast('メッセージ', i18n.t('MSG_TALENT_IMPORT_MAX_FILE_SIZE'), 'error');
      return;
    }

    return detectedEncoding(fileUpload);
  };

  const detectedEncoding = (fileUpload: any) => {
    const reader = new FileReader();

    reader.onload = () => {
      const buffer = new Uint8Array(reader.result as ArrayBuffer);
      const encoding = Encoding.detect(buffer);

      if (encoding === 'UTF8' || encoding === 'SJIS') {
        let decodedString = '';

        if (encoding === 'UTF8') {
          decodedString = new TextDecoder('utf-8').decode(buffer);
        } else if (encoding === 'SJIS') {
          decodedString = Encoding.convert(buffer, {
            to: 'UNICODE',
            from: 'SJIS',
            type: 'string',
          });
        }

        setFile(fileUpload);
        setFileDecodedString(decodedString);
      } else {
        showToast('メッセージ', i18n.t('MSG_GLOBAL_DATA_INCORRECT_FORMAT'), 'error');
      }
    };

    reader.readAsArrayBuffer(fileUpload);
  };

  const handleCancelImport = () => {
    setFile(null);
    setFileLoaded(false);
    setErrorLoaded(false);
    setErrorTable([]);
    setTableData([]);
    setFileDecodedString(null);
    dispatch(setResultImport({}));
    dispatch(setListImportSuccess([]));
    dispatch(setListImportError([]));
    dispatch(setCurrentPageSuccess(1));
    dispatch(setCurrentPageError(1));
  };

  const handleChooseNewFile = () => {
    handleCancelImport();
    fileRef.current.click();
  };

  const validateCSVHeader = (csvItem: any) => {
    if (!csvItem || csvItem.length === 0) return false;
    const csvHeaders = Object.keys(csvItem[0]);

    if (csvHeaders.length !== headerField.length) return false;

    return headerField.every((field) => csvHeaders.includes(field.label));
  };

  const handleFileUpload = async () => {
    setErrorLoaded(false);

    if (!file || !fileDecodedString) {
      showToast('メッセージ', i18n.t('MSG_GLOBAL_DATA_INCORRECT_FORMAT'), 'error');
      return;
    }

    dispatch(setLoading(true));

    const fileType = file.name.split('.').pop();
    if (fileType !== 'csv') {
      dispatch(setLoading(false));
      showToast('メッセージ', i18n.t('MSG_JOB_SELECT_FILE_CSV_FORMAT'), 'error');
      return;
    }

    Papa.parse(fileDecodedString, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        if (results.data.length > 0) {
          const validateHeaderFlag = validateCSVHeader(results.data);
          if (!validateHeaderFlag) {
            dispatch(setLoading(false));
            showToast('メッセージ', i18n.t('MSG_GLOBAL_DATA_INCORRECT_FORMAT'), 'error');
            return;
          }

          const formattedData = results.data
            .filter((row: any) => Object.values(row).some((value: any) => value && value.trim() !== ''))
            .map((row: any) => {
              const newObj: any = {};
              Object.keys(row).forEach((key) => {
                const header = headerField.find((item) => item.label === key);
                if (header) {
                  newObj[header.field] = row[key];
                }
              });
              return newObj;
            });

          dispatch(importTalent({ requestBody: { data: formattedData } }));
        } else {
          dispatch(setLoading(false));
          showToast('メッセージ', i18n.t('MSG_JOB_NO_DATA_IMPORT'), 'error');
        }
      },
    });
  };

  const handleDownloadTemplate = async () => {
    const currentRootUrl = window.location.origin;
    const fileUrl = currentRootUrl + "/static/sample-import/Template_TalentRegistration.csv";

    try {
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("File not found");

      const buffer = await response.arrayBuffer();
      const uint8ArrayRaw = new Uint8Array(buffer);
      const detectedEncoding = Encoding.detect(uint8ArrayRaw);
      let downloadBytes = uint8ArrayRaw;
      let mimeType = "text/csv;charset=UTF-8";

      if (detectedEncoding === 'UTF8') {
        const sjisDataArray = Encoding.convert(uint8ArrayRaw, { to: 'SJIS', from: 'UTF8', type: 'array' });
        downloadBytes = new Uint8Array(sjisDataArray);
        mimeType = "text/csv;charset=Shift_JIS";
      } else if (detectedEncoding === 'SJIS') {
        mimeType = "text/csv;charset=Shift_JIS";
      }

      const blob = new Blob([downloadBytes], { type: mimeType });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.download = "Template_TalentRegistration.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (e) {
      console.error(e);
    }
  };

  const handleDownloadGuide = async () => {
    const currentRootUrl = window.location.origin;
    const fileUrl = currentRootUrl + "/static/sample-import/Guide_TalentRegistrationCSV.xlsx";

    try {
      await downloadFileAttachment(fileUrl, "Guide_TalentRegistrationCSV.xlsx");
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!resultImport || (Array.isArray(resultImport) && resultImport.length === 0)) {
      setFileLoaded(false);
      setErrorLoaded(false);
      setTableData([]);
      setErrorTable([]);
      return;
    }

    if (listImportSuccess.length > 0) {
      setTableData(listImportSuccess);
      setErrorLoaded(false);
      setErrorTable([]);
    } else if (listImportError.length > 0) {
      const data = listImportError.map((item: any) => ({
        row: item.row_index,
        column: item.column,
        status: item.status,
        errorText: item.error_message,
      }));
      setErrorTable(data);
      setErrorLoaded(true);
      setFileLoaded(true);
      setTableData([]);
    } else {
      setFileLoaded(false);
      setErrorLoaded(false);
      setTableData([]);
      setErrorTable([]);
    }
  }, [resultImport, listImportSuccess, listImportError]);

  useEffect(() => {
    return () => {
      handleCancelImport();
    }
  }, [])

  const onPageChangeError = (pageNumber: number) => {
    dispatch(setCurrentPageError(pageNumber));
    const listErrorPaging = getItemsByPage(resultImport, pageNumber, importPageSize);
    dispatch(setListImportError(listErrorPaging));
  };

  const onPageChangeSuccess = (pageNumber: number) => {
    dispatch(setCurrentPageSuccess(pageNumber));
    const listSuccessPaging = getItemsByPage(resultImport, pageNumber, importPageSize);
    dispatch(setListImportSuccess(listSuccessPaging));
  };

  useEffect(() => {
    if (actionName === 'savingImportTalent') {
      if (actionStatus === 'fulfilled') {
        showToast('アップロードが完了しました。', `${file?.name} の読み込みが完了しました。`, 'success', "display_title");
        navigate('/company/talent/register');
      } else if (actionStatus === 'rejected') {
        showToast('メッセージ', message, 'error');
      }
    }
    if (actionName === 'importTalent') {
      if (actionStatus === 'fulfilled') {
        dispatch(savingImportTalent({ requestBody: { data: resultImport } }));
      } else if (actionStatus === 'rejected') {
        showToast('メッセージ', message, 'error');
      }
    }
  }, [actionName, actionStatus, message]);

  return (
    <>
      <CompanyHeader />
      <div className="mt-6 px-6 flex gap-6 relative">
        <CompanySideMenu />
        <div className="flex-1">
          <div className="mb-6 flex items-center gap-4">
            <ReturnButton onClick={() => navigate('/company/talent/register', { state: { isFromDetail: true } })} />
            <span className="text-sm alu-text-base-1">/</span>
            <h3 className="text-xl leading-[1.875rem] alu-text-base-2 font-bold">
              CSV 一括アップロード
            </h3>
          </div>

          <p className="text-sm alu-text-base-1 mb-6">
            タレント情報をCSV形式で一括アップロードします。
          </p>

          <div className="mb-6">
            <CustomButton
              variant="outline"
              size="sm"
              isCombo={true}
              comboButtons={[
                {name: "タレント登録CSVテンプレート", onClick: handleDownloadTemplate},
                {name: "タレント登録CSV作成ガイド", onClick: handleDownloadGuide}
              ]}
            >
              （テンプレートをダウンロード）
            </CustomButton>
          </div>

          <div className="bg-white rounded-lg p-6">
            <input
              accept=".csv"
              onChange={handleChangeFile}
              type="file"
              className="hidden"
              ref={fileRef}
            />
            {!file && (
              <div className="relative w-full h-[18.75rem]">
                <div className="w-full absolute top-0 left-0">
                  <div
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    onClick={handleClick}
                    className={`hover:cursor-pointer hover:bg-[#FFF3E5] hover:border-[#FF861A] rounded-lg w-full h-[18.75rem] ${
                      isOver ? 'bg-[#009CF2]' : 'bg-white'
                    } border border-dashed border-[#E0E0E0] flex flex-col gap-4 items-center justify-center`}
                  >
                    <button>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_10995_14344)">
                          <path
                            d="M12.0003 21.3333H20.0003V13.3333H25.3337L16.0003 4L6.66699 13.3333H12.0003V21.3333ZM6.66699 24H25.3337V26.6667H6.66699V24Z"
                            fill={`${isOver ? '#fff' : '#808080'}`}
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_10995_14344">
                            <rect width="32" height="32" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                    <p className={`text-sm leading-[1.3125rem] ${isOver ? 'text-white' : 'alu-text-base-1'} text-center`}>
                      ここにCSVファイルをドラッグ&ドロップ、または
                      <br />
                      <span className="text-[#FF861A]">ファイルを選択する</span>
                    </p>
                  </div>
                </div>
              </div>
            )}

            {file && (
              <>
                <div className={`${!file && "mt-4"} mb-[0.625rem] ${!fileLoaded ? 'px-4 py-2' : ''} flex items-center gap-4 rounded-lg ${!fileLoaded ? 'border' : ''} border-[#E0E0E0]`}>
                  <p className={`${!fileLoaded ? 'text-base' : 'text-sm'} ${!errorLoaded ? 'alu-text-base-2' : 'text-[#F33D62]'} font-bold`}>
                    {file.name}
                  </p>
                  <p className={`text-sm ${!fileLoaded ? 'alu-text-base-1' : !errorLoaded ? 'alu-text-base-2' : 'text-[#F33D62]'}`}>
                    {!fileLoaded
                      ? 'ファイルが選択されました'
                      : !errorLoaded
                        ? 'を読み込みました。内容を確認してください。'
                        : 'の読込中にエラーが発生しました。'}
                  </p>
                </div>
                {!fileLoaded && (
                  <div className="flex items-center gap-4">
                    <CustomButton 
                      disabled={loading}
                      size="md"
                      onClick={handleFileUpload}
                      type="button"
                    >
                      <p>{loading ? "送信中..." : "CSV を登録"}</p>
                      {loading && (
                        <span><LoadingSpinner /></span>
                      )}
                    </CustomButton>
                    <CustomButton size="md" onClick={() => navigate('/company/talent/register')} type="button" variant="outline">
                      キャンセル
                    </CustomButton>
                    <CustomButton size="md" onClick={() => setFile(null)} type="button" variant="outline">
                      別のファイルを選択する
                    </CustomButton>
                  </div>
                )}

                {errorLoaded && errorTable.length > 0 && (
                  <>
                    <table className="table-auto w-full mb-4">
                      <thead className="border-b alu-border px-4 py-2">
                        <tr>
                          {errorTableHeaders.map((header, idx) => (
                            <th key={idx} className="px-4 py-2 text-left">
                              <div className="flex items-center">
                                <p className="font-normal text-sm leading-[1.3125] alu-text-base-1">{header}</p>
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {errorTable.map((data: any, idx: any) => (
                          <tr key={idx} className="border-b border-b-[#E0E0E0] hover:bg-[#fff3e5]">
                            <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">{data.row}</td>
                            <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">{data.column}</td>
                            <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">{data.status}</td>
                            <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">{data.errorText}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="flex items-center gap-4">
                      <CustomButton type="button" variant="text" onClick={handleCancelImport}>
                        読み込みをキャンセル
                      </CustomButton>
                      <CustomButton type="button" size="md" onClick={handleChooseNewFile}>
                        ファイルを指定し直す
                      </CustomButton>
                    </div>
                    {resultImport?.length > importPageSize && (
                      <div className="mt-4 flex justify-center">
                        <CustomPagination
                          total={resultImport?.length}
                          currentPage={currentPageError}
                          pageSize={importPageSize}
                          onPageChange={onPageChangeError}
                        />
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <Copyright view="company" />
    </>
  );
};

export default TalentCSV;
